import React from 'react'
import { AiFillCamera, AiOutlineComment,  AiFillExclamationCircle } from 'react-icons/ai';
import { IoIosAddCircleOutline } from 'react-icons/io';
import {useStateContext} from '../context/StateContext';
import { userLogCheck, isDeviceSevere } from '../lib/utils';
import VisDiv from './frontend_components/VisDiv';
import { facilityClient, clientUser } from '../lib/userPermissions';
import { MdOutlineQrCodeScanner } from "react-icons/md";

const DeviceIcons = ({device, nonConformities, duplicateFn, hideDuplicateButton}) => {
    const {
        sUser,
        client,  
    } = useStateContext();

  
    const photosPresent = (device) => {
        const nPhotosInComments = !Array.isArray(device?.comments) ? [] : 
        device?.comments?.filter?.((comment) => {
            if(comment?.status == "ARCHIVIATO") return false
            if(!Array.isArray(comment?.images)) return []
            if(!clientUser(sUser)) return comment?.images?.length > 0 && comment?.severe
            return comment?.images?.length > 0
        })?.map?.((comment) => !Array.isArray(comment?.images) ? [] : comment?.images?.map?.((image) => {
            if(image?.before && image?.after) return 2
            if(image?.before && !image?.after) return 1
            if(!image?.before && image?.after) return 1
            return  0
        }))?.flat()?.reduce((a, b) => a + b, 0)
        const nPhotosInImages = !Array.isArray(device?.image) ? [] : device?.image?.length
        const nPhotos = 
        ((!nPhotosInComments || Number.isNaN(nPhotosInComments)) ? 0 : nPhotosInComments) + 
        ((!nPhotosInImages || Number.isNaN(nPhotosInImages)) ? 0 : nPhotosInImages)
        
        //if(device?._id == "9f079bff-fc46-4802-b53c-e64ca8261da6") console.log("lkajnfkwrfvn", device, {is:true, length: nPhotosInComments, photosInComments: nPhotos})  
        if (device?.image?.length > 0) return {is:true, length: nPhotos}
        if(nPhotosInComments > 0 ) return  {is:true, length: nPhotos}
        return ({is: false, length: 0})
    }   
    const iconContainerStyle = {display:"flex", flexDirection:"row", justifyCoontent: "flex-end", alignItems:"center"}
    const numberContainerStyle = {marginRight:"3px", fontSize:"10px", backgroundColor:"blue", flex:1, color:"white", padding:"5px", width:"18px", height:"18px",borderRadius:"50px", display:"flex", justifyContent:"center", alignItems:"center"}

    const nComments = !Array.isArray(device?.comments) ? 0 : device?.comments?.filter?.((x)=>{
        //x?.severe se si vuol vedere solo i severi
        if (sUser?.userType == "Cliente") return x?.status !== "ARCHIVIATO" && x?.severe
        return x?.status !== "ARCHIVIATO"
    })?.length
    const severeDevice = isDeviceSevere(device, nonConformities)
    return (
    <>
        <div className='icon-container' style={{display:"flex", flexDirection:"column", justifyContent:"space-evenly", alignItems:"flex-end"}}>
                
                <VisDiv rules={[!hideDuplicateButton, facilityClient(client, sUser), clientUser(sUser)]} style={iconContainerStyle}>
                    <button className="device-pin-icon" onClick={(e) => {duplicateFn(e)}} type="button">
                        <IoIosAddCircleOutline fontSize={30} />
                    </button>
                </VisDiv>
                <VisDiv rules={[device?.qrUrl]}>
                    <MdOutlineQrCodeScanner size={25} color='grey'/>
                </VisDiv>
                <VisDiv rules={[severeDevice]}><AiFillExclamationCircle fontSize={27} color='red' /></VisDiv>
                <VisDiv rules={[photosPresent(device).is]} style={iconContainerStyle}>
                    <div style={numberContainerStyle}>
                        {photosPresent(device).length}
                    </div>
                    
                    <button className="device-pin-icon" onClick={()=>console.log(device)} type="button">
                        <AiFillCamera fontSize={30}/> 
                    </button>  
                         
                </VisDiv>
                <VisDiv rules={[nComments > 0]}  style={iconContainerStyle}>
                    <div style={numberContainerStyle}>
                        {nComments}
                    </div>
                    <button className="device-pin-icon" type="button">
                        <AiOutlineComment fontSize={30} />
                    </button>                     
                </VisDiv>


        </div>
    </>
)}

export default DeviceIcons
